import { pluralForm, pluralize } from "@/utils/plural"

// "1 складской и 3 РХ заказа" — слово "заказ" одно на всю фразу,
// его форма зависит от последнего числа, прилагательное — от своего.
const WAREHOUSE = ["складской", "складских", "складских"]
const ORDER = ["заказ", "заказа", "заказов"]

// Значение бейджа: "5/2" — позиций и заказов.
// При единственном заказе число заказов не показываем, при отсутствии позиций бейджа нет.
const countLabel = (items: number, orders: number): string | null =>
  items ? `${items}${orders === 1 ? "" : `/${orders}`}` : null

export default {
  getOrdersLength: (_state: any) => Object.keys(_state.orders || {}).length,

  getCartCountTotal: (_state: any) =>
    countLabel(
      _state.warehouseItemsCount + _state.rxItemsCount,
      _state.warehouseOrdersCount + _state.rxOrdersCount
    ),

  getCartCountWarehouse: (_state: any) =>
    countLabel(_state.warehouseItemsCount, _state.warehouseOrdersCount),

  getCartCountRX: (_state: any) =>
    countLabel(_state.rxItemsCount, _state.rxOrdersCount),

  getCartReminder: (_state: any): string => {
    const warehouse = _state.warehouseOrdersCount
    const rx = _state.rxOrdersCount
    const parts = []

    if (warehouse) parts.push(pluralize(warehouse, WAREHOUSE))
    if (rx) parts.push(`${rx} РХ`)
    if (!parts.length) return ""

    // Форму "заказ" задаёт последнее упомянутое число
    return `В корзине: ${parts.join(" и ")} ${pluralForm(rx || warehouse, ORDER)}`
  },
}
